import { Card } from "antd";
import React, { useEffect } from "react";
import { CustIcon } from "../../../Svgs";
import { SealShareModal } from "../../../Modals/SealShareModal/SealShareModal";
import "./SummaryCard.less";

export const SummaryCard = ({
	onShowModal,
	count,
	icon,
	subText,
	title,
	colorClass,
	onHideModal,
	isModalVisible,
	bussiness_name
}) => {
	return (
		<>
			<Card className="summaryBox" onClick={onShowModal}>
				<div className="d-flex justify-content-between">
					<CustIcon type={icon} className={colorClass} />
					<h3>{count}</h3>
				</div>
				<div className="sTopic">
					<p>{subText}</p>
					<h4>{title}</h4>
				</div>
			</Card>
			{isModalVisible && (
				<SealShareModal
					onHideModal={onHideModal}
					count={count.slice(0, -1)}
					bussiness_name={bussiness_name}
				/>
			)}
		</>
	);
};
